/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AlertAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import React from 'react'
import TysiaNotifications from 'DesignSystem/Svgs/TysiaNotifications/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AlertAction({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/ListInput/ToggleInput/Option/AlertAction",
  isSelected
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let listAlertsValueData = fromData.useDataValue({ viewPath,
context: 'list',
path: 'alerts',
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let aggregateData = fromHelpers.isAlertActive(listAlertsValueData, optionTextValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsOrange400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.400'
        })
  return (<React.Fragment
>
<div
  data-testid="AlertAction.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-dAPSo': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-2-dAPSo': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 cursor="pointer"
 paddingBottom={0}
 paddingTop={0}
 paddingLeft={0}
 paddingRight={0}
 onClick={onClick}
 data="list.alerts"
 data="option.text"
 aggregate="helpers.js isAlertActive"
 isSelected={aggregateData}
 selectedBackgroundColor="white"
 hoveredBackgroundColor="white"
>
{childProps => (
<TysiaNotifications
{...childProps}
  viewPath={`${viewPath}/TysiaNotifications`}
 width={dtSpaceS}
 height={dtSpaceS}
 stroke={childProps.isSelected ? dtColorsOrange400 : dtColorsNeutral400}
 fill={childProps.isSelected ? dtColorsOrange400 : dtColorsNeutral400}
/>
)}
</ButtonIcon>
</div>
{children}
</React.Fragment>)
}